export const groupHelpHint = "Select this Rule Group to see details of the rules within it and how they interact.";
